import type { IconData } from '@stacksjs/iconify-core'

export const plane: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m10.725 9.094l-5.509 5.51l-1.87-.777l-.167.169l2.38 1.587l1.588 2.38l.168-.168l-.776-1.87l5.509-5.508l4.328 6.252l.21-.208l-2.887-7.696l4.4-4.398a.935.935 0 0 0-1.323-1.323l-4.4 4.399l-7.694-2.886l-.21.209zm5.39 10.483l-4.33-6.253l-3.04 3.04l.777 1.87l-2.666 2.665l-2.645-3.967l-3.968-2.646l2.666-2.666l1.869.776l3.04-3.04l-6.253-4.328l2.646-2.645l7.695 2.885l3.547-3.547a2.806 2.806 0 1 1 3.968 3.968l-3.547 3.547l2.886 7.696l-2.646 2.645z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default plane
